import { QueryKey, useInfiniteQuery, UseInfiniteQueryOptions } from 'react-query';
import { castingDao } from 'shared/dao/castingDao';
import {
  IAgencyCastingCompanyRequestPayload,
  IAgencyCastingCompanyResponsePayload,
  ICastingCompanyResponsePayload,
  ICastingListRequestPayload,
  ICastingListResponsePayload,
} from 'shared/interfaces/ICasting';

import { IAxiosErrorResponse } from 'shared/interfaces/utils/IAxios';

const {
  searchCastingProjects: searchCastingProjectsDao,
  searchAgencyCastingCompanies: searchAgencyCastingCompaniesDao,
  searchCastingCompanies: searchCastingCompaniesDao,
} = castingDao();

export const castingService = () => {
  const searchCastingProjects = (
    payload: ICastingListRequestPayload,
    options?: Omit<
      UseInfiniteQueryOptions<ICastingListResponsePayload, IAxiosErrorResponse, ICastingListResponsePayload, QueryKey>,
      'queryKey' | 'queryFn'
    >,
  ) => {
    return useInfiniteQuery<ICastingListResponsePayload, IAxiosErrorResponse, ICastingListResponsePayload>(
      ['talent_listing_data', payload],
      ({ pageParam = '' }) => searchCastingProjectsDao({ ...payload, after: pageParam }),
      {
        getNextPageParam: (lastPage) => {
          return lastPage.data.agency_casting_projects.pageInfo.hasNextPage
            ? lastPage.data.agency_casting_projects.pageInfo.endCursor
            : undefined;
        },
        enabled: options?.enabled,
      },
    );
  };

  const searchAgencyCastingCompanies = (
    payload: IAgencyCastingCompanyRequestPayload,
    options?: Omit<
      UseInfiniteQueryOptions<
        IAgencyCastingCompanyResponsePayload,
        IAxiosErrorResponse,
        IAgencyCastingCompanyResponsePayload,
        QueryKey
      >,
      'queryKey' | 'queryFn'
    >,
  ) => {
    return useInfiniteQuery<
      IAgencyCastingCompanyResponsePayload,
      IAxiosErrorResponse,
      IAgencyCastingCompanyResponsePayload
    >(
      ['casting_companies', payload],
      ({ pageParam = '' }) => searchAgencyCastingCompaniesDao({ ...payload, after: pageParam }),
      {
        getNextPageParam: (lastPage) => {
          return lastPage.data.agency_casting_companies_connection.pageInfo.hasNextPage
            ? lastPage.data.agency_casting_companies_connection.pageInfo.endCursor
            : undefined;
        },
        enabled: options?.enabled,
      },
    );
  };

  const searchCastingCompanies = (
    payload: IAgencyCastingCompanyRequestPayload,
    options?: Omit<
      UseInfiniteQueryOptions<
        ICastingCompanyResponsePayload,
        IAxiosErrorResponse,
        ICastingCompanyResponsePayload,
        QueryKey
      >,
      'queryKey' | 'queryFn'
    >,
  ) => {
    return useInfiniteQuery<ICastingCompanyResponsePayload, IAxiosErrorResponse, ICastingCompanyResponsePayload>(
      ['casting_companies', payload],
      ({ pageParam = '' }) => searchCastingCompaniesDao({ ...payload, after: pageParam }),
      {
        getNextPageParam: (lastPage) => {
          return lastPage.data.casting_companies_connection.pageInfo.hasNextPage
            ? lastPage.data.casting_companies_connection.pageInfo.endCursor
            : undefined;
        },
        enabled: options?.enabled,
      },
    );
  };

  return {
    searchCastingProjects,
    searchAgencyCastingCompanies,
    searchCastingCompanies,
  };
};
